export function formatCNPJ(cnpj: string) {
	if (!cnpj || cnpj === "undefined") return "";

	const cnpjString = cnpj.padStart(14, "0");
	const cnpjMask = cnpjString.replace(
		/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
		"$1.$2.$3/$4-$5"
	);
	return cnpjMask;
}

export function cleanCNPJ(cnpj: string | undefined): string {
	if (!cnpj || cnpj === "undefined") return "";

	// Remove todos os caracteres não numéricos
	const numbers = cnpj.replace(/\D/g, "");

	// return parseInt(numbers).toString();

	// Garante que terá 14 dígitos, preenchendo com zeros à esquerda se necessário
	return numbers.padStart(14, "0");
}
